// extracted by mini-css-extract-plugin
module.exports = {"title":"FiltersHrSearchDialog_title_7uyA7","resetButton":"FiltersHrSearchDialog_resetButton_1Dg8o"};